import React, { FunctionComponent } from 'react'

type ProviderReducer = (providers: Array<FunctionComponent>) => FunctionComponent
export const combineProviders: ProviderReducer = providers => providers.reduce((Combined, Provider) => ({ children }) => (
	<Combined>
		<Provider>{children}</Provider>
	</Combined>
))
